import validatePhone from "phone";

export const validateInputPhone = (phone: string) => {
  const formattedPhone = phone?.replace(/\D+/g, '');
  return validatePhone(formattedPhone, {country: 'IL'}).isValid;
}
